(() => {
  const init = (root) => {
    if (!root || root.dataset.ilmoReady) return;
    root.dataset.ilmoReady = 'true';

    const gallery = root.querySelector('[data-ilmo-gallery]');
    const mainImage = gallery?.querySelector('[data-ilmo-main-image]');
    const mainImageWrap = gallery?.querySelector('.ilmo-gallery__main');
    const thumbs = [...(gallery?.querySelectorAll('[data-ilmo-thumb]') || [])];
    let activeImageIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

    const setGalleryImage = (index) => {
      if (!mainImage || !thumbs.length) return;
      const nextIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[nextIndex];
      if (!thumb?.dataset.imageSrc) return;

      activeImageIndex = nextIndex;
      mainImage.style.opacity = '0';
      window.setTimeout(() => {
        mainImage.src = thumb.dataset.imageSrc;
        mainImage.removeAttribute('srcset');
        mainImage.style.opacity = '1';
      }, 160);

      thumbs.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === nextIndex);
        item.setAttribute('aria-current', itemIndex === nextIndex ? 'true' : 'false');
      });
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => setGalleryImage(index));
    });

    if (mainImageWrap && thumbs.length > 1) {
      let swipeStartX = 0;
      let swipeStartY = 0;
      let swipeTracking = false;
      let swipePointerId = null;

      const releaseSwipePointer = () => {
        if (swipePointerId === null) return;
        try {
          mainImageWrap.releasePointerCapture?.(swipePointerId);
        } catch (_error) {}
        swipePointerId = null;
      };

      mainImageWrap.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary) return;
        swipeTracking = true;
        swipePointerId = event.pointerId;
        swipeStartX = event.clientX;
        swipeStartY = event.clientY;
        mainImageWrap.setPointerCapture?.(event.pointerId);
      });

      mainImageWrap.addEventListener('pointerup', (event) => {
        if (!swipeTracking || !event.isPrimary) return;
        swipeTracking = false;
        releaseSwipePointer();

        const deltaX = event.clientX - swipeStartX;
        const deltaY = event.clientY - swipeStartY;
        const minSwipe = Math.max(36, mainImageWrap.clientWidth * 0.12);
        if (Math.abs(deltaX) < minSwipe || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;

        setGalleryImage(activeImageIndex + (deltaX < 0 ? 1 : -1));
      });

      mainImageWrap.addEventListener('pointercancel', () => {
        swipeTracking = false;
        releaseSwipePointer();
      });
    }

    const quantity = root.querySelector('[data-ilmo-quantity]');
    root.querySelector('[data-ilmo-quantity-minus]')?.addEventListener('click', () => {
      if (!quantity) return;
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
    root.querySelector('[data-ilmo-quantity-plus]')?.addEventListener('click', () => {
      if (!quantity) return;
      quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
    });

    const variantData = root.querySelector('[data-ilmo-variants]');
    const variantIdInput = root.querySelector('[data-ilmo-variant-id]');
    const price = root.querySelector('[data-ilmo-price]');
    const stock = root.querySelector('[data-ilmo-stock]');
    const stockText = root.querySelector('[data-ilmo-stock-text]');
    const addButton = root.querySelector('button[name="add"]');
    const addLabel = root.querySelector('[data-ilmo-add-label]');
    const addPrice = root.querySelector('[data-ilmo-add-price]');
    let variants = [];

    try {
      variants = JSON.parse(variantData?.textContent || '[]');
    } catch (_error) {
      variants = [];
    }

    const updateProductVariant = () => {
      if (!variants.length) return;

      const selectedOptions = [...root.querySelectorAll('.ilmo-option')].map((fieldset) => {
        return fieldset.querySelector('input[type="radio"]:checked')?.value;
      });
      const variant = variants.find((candidate) => {
        return candidate.options.length === selectedOptions.length
          && candidate.options.every((option, index) => option === selectedOptions[index]);
      });

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'NICHT VERFÜGBAR';
        if (stock) stock.hidden = true;
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;
      if (price) price.textContent = variant.price;
      if (addPrice) addPrice.textContent = variant.price;
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'IN DEN WARENKORB' : 'AUSVERKAUFT';

      const lowStock = variant.inventoryManagement
        && variant.inventoryQuantity > 0
        && variant.inventoryQuantity <= 5;

      if (stock) stock.hidden = !lowStock;
      if (stockText) {
        stockText.textContent = lowStock
          ? variant.inventoryQuantity === 1
            ? 'Nur noch 1 Stück auf Lager'
            : `Nur noch ${variant.inventoryQuantity} Stück auf Lager`
          : '';
      }

      root.dispatchEvent(new CustomEvent('ilamo:variant-change', {
        bubbles: true,
        detail: { variant },
      }));
    };

    root.querySelectorAll('.ilmo-option input[type="radio"]').forEach((input) => {
      input.addEventListener('change', updateProductVariant);
    });

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals = [...root.querySelectorAll('.ilmo-reveal')];
    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach((el) => el.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach((el) => observer.observe(el));
    }

    const media = window.matchMedia('(max-width: 749px)');
    const syncAccordions = () => root.querySelectorAll('[data-ilmo-accordion]').forEach((details, index) => {
      if (media.matches) {
        if (!details.dataset.ilmoMobileSet) details.open = index === 0;
        details.dataset.ilmoMobileSet = 'true';
      } else {
        details.open = true;
        delete details.dataset.ilmoMobileSet;
      }
    });
    syncAccordions();
    media.addEventListener?.('change', syncAccordions);

    const sticky = root.querySelector('[data-ilmo-sticky]');
    const mainProduct = root.querySelector('.ilmo-hero');
    if (sticky && mainProduct && media.matches) {
      sticky.hidden = false;
      const stickyObserver = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-active', !entry.isIntersecting), { threshold: 0.05 });
      stickyObserver.observe(mainProduct);
      sticky.querySelector('[data-ilmo-sticky-submit]')?.addEventListener('click', () => {
        const add = mainProduct.querySelector('button[name="add"]:not([disabled])');
        add?.click();
      });
      const updateSticky = () => {
        const selectedPrice = mainProduct.querySelector('[data-ilmo-price]')?.textContent?.trim();
        if (selectedPrice) sticky.querySelector('[data-ilmo-sticky-price]').textContent = selectedPrice;
        const add = mainProduct.querySelector('button[name="add"]');
        const button = sticky.querySelector('[data-ilmo-sticky-submit]');
        if (add && button) {
          button.disabled = add.disabled;
          button.textContent = add.disabled ? 'AUSVERKAUFT' : 'IN DEN WARENKORB';
        }
      };
      mainProduct.addEventListener('change', () => setTimeout(updateSticky, 50));
      document.addEventListener('variant:change', updateSticky);
      root.addEventListener('ilamo:variant-change', updateSticky);
    }
  };

  const boot = () => document.querySelectorAll('[data-ilmo-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
